import API from '../endpoints';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Article, ArticleOrder, ArticleSort, PaginatedResponse, TagsMatchMode } from '@repo/types';
import { getAccessToken } from '../utils/getAccessToken';

const accessToken = getAccessToken();

// 2 minutes frontend cache for article list query
const CACHE_TIME = 2 * 60 * 1000;

export type ArticlesQueryArgs = {
  tags?: string;
  tagsMatchMode?: TagsMatchMode;
  startDate?: string;
  endDate?: string;
  limit?: number;
  page?: number;
  sort?: ArticleSort;
  order?: ArticleOrder;
  shared?: boolean;
  ignorePublishDate?: boolean;
  excludeIds?: string;
  excludeTags?: string;
};

type QueryOptions = {
  enabled: boolean;
};

export const useArticlesQuery = (args: ArticlesQueryArgs, options?: QueryOptions) => {
  return useQuery({
    queryKey: ['articles', args],
    queryFn: fetchArticles,
    staleTime: !accessToken ? CACHE_TIME : undefined,
    ...(options ?? {}),
  });
};

const fetchArticles: QueryFunction<PaginatedResponse<Article>, [string, ArticlesQueryArgs]> = async ({ queryKey }) => {
  const [, params] = queryKey;

  const { data } = await axios.get<PaginatedResponse<Article>>(API.endpoints.articles, {
    params,
  });
  return data;
};
